var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagingDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f9476638-98d6-47a7-a5f0-58e97409b935",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.3,
    height: 70.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68.3 70.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-e1339442-ca09-401e-a085-b3c0a57b4037{fill:url(#uuid-db2db048-1873-4bdb-a909-75926ec78a79);}.uuid-90ea1dd8-1c59-4566-ac60-012eb3764cce{fill:url(#uuid-5ca121c5-e81d-4f84-89c4-c185684f491f);}.uuid-1e927654-4213-441b-b257-d5cedf8baea3{fill:url(#uuid-a40e386f-1eb4-4da7-acf6-5f40f47a8764);}.uuid-cb04b3a1-d222-47e2-abb1-913700ec218f{fill:url(#uuid-2cef3774-564c-4a1e-aa18-f357366c8175);}.uuid-befe9b67-45d0-4c81-aecc-c223958122cb{fill:url(#uuid-a9cd3f0c-dbe8-4765-8aea-4868cbc5419f);}.uuid-f7a123c3-aa69-4dd9-8e3f-8c348d89432d{fill:url(#uuid-0b10f060-6d09-46b5-8f53-546d6e5c6580);}.uuid-eb4e4239-5a6b-4158-be46-1de29cc9d51a{fill:url(#uuid-c7e674d4-b1f3-4873-85ec-d00a752411df);}.uuid-7fe2abb6-afdc-4a31-bf32-39eb9949ffd9{fill:url(#uuid-a175f87e-2bd9-4997-8417-501405c35c1a);}.uuid-c6e21c13-d62f-40ca-8bfc-b47d3cdf9249{fill:url(#uuid-a2be2ab0-91b8-4128-a275-cf5d618fe2e2);}.uuid-f69c4c26-8599-4ee2-84ef-b31a0e448b1c{fill:url(#uuid-3f86670a-d80f-42c2-9a5b-2ab0211d8710);}.uuid-7cc7017e-0a1a-4e63-be38-532d3438cfbb{fill:url(#uuid-e481895d-1e9a-44e4-933c-8041170e28cd);}.uuid-88db7f72-2d55-4581-82dd-5e906c98f5eb{fill:url(#uuid-b1df2794-fca5-4366-abed-65d6b419c48e);}.uuid-154c6593-e56c-47c4-a01d-81202b9c5cd4{fill:url(#uuid-1bd7d9f2-0908-4479-a19a-2cd44beace0b);}.uuid-2173ded8-6f49-4414-b10a-c9002548ee56{fill:url(#uuid-b7be0974-82de-4bff-9799-f6a36db2124c);}.uuid-eec9c258-e85a-4903-ae88-6bff6be9534c{fill:url(#uuid-ccb45f43-4b15-42d5-a685-2b7860931c7a);}.uuid-0cdbf39e-6e86-4718-ab7f-ac3c8d713b52{fill:url(#uuid-504734e1-686d-4f7d-85ff-8d268ec9de36);}.uuid-f507aa55-dbd9-4233-90fd-05ca35dd722f{fill:url(#uuid-f4e8f183-7641-4212-b6de-d2f8b705a1ac);}.uuid-88300a3b-d17b-430a-9672-bad06e0124f4{fill:url(#uuid-a0a728fa-ba70-4cb4-82e4-b4db992acc65);}.uuid-c8f16124-ae74-4990-a58c-b98a13f05f35{fill:url(#uuid-70dce667-5c05-46cd-9859-09307dfd2dc1);}.uuid-f78c26d3-00e8-45a9-90c3-0a38e63c506d{fill:url(#uuid-fccccb44-2cfd-4eed-824b-b7f602b2e099);}.uuid-7f967009-bcf1-49b4-b774-a1f49941394f{fill:url(#uuid-2dd36dfd-1ae0-4135-b092-1702eeedbe0c);}.uuid-7251dbb4-513a-40d0-aac1-a55f355de765{fill:url(#uuid-5961a716-e312-447a-b18a-47c22a3bd110);}.uuid-79b87dfc-9b09-4c8e-b47b-7c417fe1a112{fill:url(#uuid-0ff7de49-90d0-4104-9a99-6692495af167);}.uuid-c62e49ba-8a92-4159-8318-fc2cb875e175{fill:url(#uuid-2d3bb778-78d9-4314-ab76-2c4b16f5369b);}.uuid-97ac2dc2-0a76-4d61-8c89-775ff90cbda2{fill:url(#uuid-09c8c0f8-d7f2-4e95-bed8-6f3292464c85);}.uuid-3a18c988-6550-4dd3-96f1-c5afa55cd5f4{fill:url(#uuid-310ecffd-394c-462b-9b87-4ed611b255dc);}.uuid-87ac5d38-a927-4853-98fd-a402defc641a{fill:url(#uuid-7c0faa75-76c5-414f-96b5-930ee6b4dd7b);}.uuid-02e59b1a-d4f3-4999-addc-fae8b797f813{fill:url(#uuid-d087c573-0523-4deb-84d7-a7f3675a3537);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b1df2794-fca5-4366-abed-65d6b419c48e",
    x1: 58.7,
    y1: 58.5,
    x2: 59.9,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7c0faa75-76c5-414f-96b5-930ee6b4dd7b",
    x1: 50.9,
    y1: 43,
    x2: 59.9,
    y2: 43,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-fccccb44-2cfd-4eed-824b-b7f602b2e099",
    x1: 8.4,
    y1: 43,
    x2: 17.4,
    y2: 43,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-2d3bb778-78d9-4314-ab76-2c4b16f5369b",
    x1: 8.4,
    y1: 58.5,
    x2: 9.6,
    y2: 58.5,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e481895d-1e9a-44e4-933c-8041170e28cd",
    x1: 3.8,
    y1: 67,
    x2: 64.5,
    y2: 67,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b7be0974-82de-4bff-9799-f6a36db2124c",
    x1: 0,
    y1: 55.1,
    x2: 6.7,
    y2: 55.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f4e8f183-7641-4212-b6de-d2f8b705a1ac",
    x1: 0,
    y1: 52.8,
    x2: 17.5,
    y2: 52.8,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0b10f060-6d09-46b5-8f53-546d6e5c6580",
    x1: 61.6,
    y1: 55.1,
    x2: 68.3,
    y2: 55.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d087c573-0523-4deb-84d7-a7f3675a3537",
    x1: 50.8,
    y1: 52.8,
    x2: 68.3,
    y2: 52.8,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5ca121c5-e81d-4f84-89c4-c185684f491f",
    x1: 29.5,
    y1: 8,
    x2: 38.8,
    y2: 8,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ccb45f43-4b15-42d5-a685-2b7860931c7a",
    x1: 33.6,
    y1: 13.3,
    x2: 34.7,
    y2: 13.3,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-2cef3774-564c-4a1e-aa18-f357366c8175",
    x1: 18.8,
    y1: 30.2,
    x2: 49.6,
    y2: 30.2,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-09c8c0f8-d7f2-4e95-bed8-6f3292464c85",
    x1: 18.8,
    y1: 42.4,
    x2: 34.7,
    y2: 42.4,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1bd7d9f2-0908-4479-a19a-2cd44beace0b",
    x1: 33.6,
    y1: 42.4,
    x2: 49.6,
    y2: 42.4,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a40e386f-1eb4-4da7-acf6-5f40f47a8764",
    x1: 42.7,
    y1: 11.1,
    x2: 60,
    y2: 11.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a9cd3f0c-dbe8-4765-8aea-4868cbc5419f",
    x1: 40.6,
    y1: 18.3,
    x2: 47.6,
    y2: 18.3,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-db2db048-1873-4bdb-a909-75926ec78a79",
    x1: 55.1,
    y1: 3.7,
    x2: 62.4,
    y2: 3.7,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c7e674d4-b1f3-4873-85ec-d00a752411df",
    x1: 39.8,
    y1: 21.6,
    x2: 41.9,
    y2: 21.6,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a0a728fa-ba70-4cb4-82e4-b4db992acc65",
    x1: 19.7,
    y1: 59.1,
    x2: 48.6,
    y2: 59.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5961a716-e312-447a-b18a-47c22a3bd110",
    x1: 23.2,
    y1: 59.1,
    x2: 24.3,
    y2: 59.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a2be2ab0-91b8-4128-a275-cf5d618fe2e2",
    x1: 26.7,
    y1: 59.1,
    x2: 27.8,
    y2: 59.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-2dd36dfd-1ae0-4135-b092-1702eeedbe0c",
    x1: 30.1,
    y1: 59.1,
    x2: 31.3,
    y2: 59.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-70dce667-5c05-46cd-9859-09307dfd2dc1",
    x1: 33.6,
    y1: 59.1,
    x2: 34.7,
    y2: 59.1,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3f86670a-d80f-42c2-9a5b-2ab0211d8710",
    x1: 4.2,
    y1: 26,
    x2: 16.5,
    y2: 26,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a175f87e-2bd9-4997-8417-501405c35c1a",
    x1: 7.3,
    y1: 26,
    x2: 13.4,
    y2: 26,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-310ecffd-394c-462b-9b87-4ed611b255dc",
    x1: 51.8,
    y1: 26,
    x2: 64.1,
    y2: 26,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-504734e1-686d-4f7d-85ff-8d268ec9de36",
    x1: 54.9,
    y1: 26,
    x2: 61.1,
    y2: 26,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0ff7de49-90d0-4104-9a99-6692495af167",
    x1: 57.4,
    y1: 26,
    x2: 58.5,
    y2: 26,
    xlinkHref: "#uuid-b1df2794-fca5-4366-abed-65d6b419c48e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-0e291e0e-f8be-414a-bc33-57810914e9f9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-88db7f72-2d55-4581-82dd-5e906c98f5eb",
    x: 58.7,
    y: 52.6,
    width: 1.1,
    height: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-87ac5d38-a927-4853-98fd-a402defc641a",
    d: "M59.3,50.4c-.3,0-.6-.3-.6-.6v-13.1h-7.3c-.3,0-.6-.3-.6-.6s.3-.6.6-.6h7.3c.6,0,1.1.5,1.1,1.1v13.1c0,.3-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f78c26d3-00e8-45a9-90c3-0a38e63c506d",
    d: "M9,50.4c-.3,0-.6-.3-.6-.6v-13.1c0-.6.5-1.1,1.1-1.1h7.3c.3,0,.6.3.6.6s-.3.6-.6.6h-7.3v13.1c0,.3-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c62e49ba-8a92-4159-8318-fc2cb875e175",
    x: 8.4,
    y: 52.6,
    width: 1.1,
    height: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7cc7017e-0a1a-4e63-be38-532d3438cfbb",
    d: "M59.4,70.1H8.9c-2.8,0-5.1-2.3-5.1-5.1v-.6c0-.3.3-.6.6-.6h22.2c.3,0,.6.3.6.6v1.4h14.1v-1.4c0-.3.3-.6.6-.6h22.2c.3,0,.6.3.6.6v.6c0,2.8-2.3,5.1-5.1,5.1ZM4.9,65c0,2.2,1.8,4,4,4h50.4c2.2,0,4-1.8,4-4h-21v1c0,.5-.4,1-1,1h-14.5c-.5,0-1-.4-1-1v-1H4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2173ded8-6f49-4414-b10a-c9002548ee56",
    d: "M6.1,59.3c0,0-.1,0-.2,0l-5.6-1.8c-.3,0-.5-.4-.4-.7l1.8-5.6c0-.3.4-.5.7-.4.3,0,.5.4.4.7l-1.6,5,5,1.6c.3,0,.5.4.4.7,0,.2-.3.4-.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f507aa55-dbd9-4233-90fd-05ca35dd722f",
    d: "M.6,57.5c-.2,0-.4-.1-.5-.3-.1-.3,0-.6.2-.8l16.3-8.3c.3-.1.6,0,.8.2.1.3,0,.6-.2.8L.8,57.4c0,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f7a123c3-aa69-4dd9-8e3f-8c348d89432d",
    d: "M62.2,59.3c-.2,0-.5-.2-.5-.4,0-.3,0-.6.4-.7l5-1.6-1.6-5c0-.3,0-.6.4-.7.3,0,.6,0,.7.4l1.8,5.6c0,.3,0,.6-.4.7l-5.6,1.8c0,0-.1,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-02e59b1a-d4f3-4999-addc-fae8b797f813",
    d: "M67.7,57.5c0,0-.2,0-.3,0l-16.3-8.3c-.3-.1-.4-.5-.2-.8.1-.3.5-.4.8-.2l16.3,8.3c.3.1.4.5.2.8-.1.2-.3.3-.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-90ea1dd8-1c59-4566-ac60-012eb3764cce",
    d: "M38.3,10.6c-.1,0-.3,0-.4-.2l-3.7-3.7-3.7,3.7c-.2.2-.6.2-.8,0-.2-.2-.2-.6,0-.8l4.1-4.1c.2-.2.6-.2.8,0l4.1,4.1c.2.2.2.6,0,.8-.1.1-.3.2-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-eec9c258-e85a-4903-ae88-6bff6be9534c",
    d: "M34.2,21.2c-.3,0-.6-.3-.6-.6V5.9c0-.3.3-.6.6-.6s.6.3.6.6v14.8c0,.3-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-cb04b3a1-d222-47e2-abb1-913700ec218f",
    d: "M34.2,38c0,0-.2,0-.2,0l-14.8-7.2c-.2,0-.3-.3-.3-.5s.1-.4.3-.5l14.8-7.2c.2,0,.3,0,.5,0l14.8,7.2c.2,0,.3.3.3.5s-.1.4-.3.5l-14.8,7.2c0,0-.2,0-.2,0ZM20.6,30.2l13.5,6.6,13.5-6.6-13.5-6.6-13.5,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-97ac2dc2-0a76-4d61-8c89-775ff90cbda2",
    d: "M34.2,55.1c0,0-.2,0-.2,0l-14.8-7.2c-.2,0-.3-.3-.3-.5v-17.1c0-.2.1-.4.3-.5.2-.1.4-.1.6,0l14.8,7.2c.3.1.4.5.3.8-.1.3-.5.4-.8.3l-14-6.8v15.9l14.5,7c.3.1.4.5.3.8-.1.2-.3.3-.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-154c6593-e56c-47c4-a01d-81202b9c5cd4",
    d: "M34.2,55.1c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5v-17.1c0-.2.1-.4.3-.5l14.8-7.2c.2,0,.4,0,.6,0,.2.1.3.3.3.5v17.1c0,.2-.1.4-.3.5l-14.8,7.2c0,0-.2,0-.2,0ZM34.7,37.8v15.9l13.7-6.6v-15.9l-13.7,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1e927654-4213-441b-b257-d5cedf8baea3",
    d: "M47,19.8c-.2,0-.3,0-.4-.2l-3.8-3.8c-.2-.2-.2-.6,0-.8l2.7-2.7c.2-.2.6-.2.8,0,.2.2.2.6,0,.8l-2.3,2.3,3,3,11.6-11.6-3-3-7.2,7.2c-.2.2-.6.2-.8,0-.2-.2-.2-.6,0-.8l7.6-7.6c.2-.2.6-.2.8,0l3.8,3.8c.2.2.2.6,0,.8l-12.4,12.4c-.1.1-.3.2-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-befe9b67-45d0-4c81-aecc-c223958122cb",
    d: "M41.7,21.8c-.3,0-.5-.1-.7-.3-.3-.3-.4-.7-.2-1.1l2-5.2c.1-.3.4-.4.7-.3.3.1.4.4.3.7l-1.9,5,5-1.9c.3-.1.6,0,.7.3.1.3,0,.6-.3.7l-5.2,2c-.1,0-.3,0-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e1339442-ca09-401e-a085-b3c0a57b4037",
    d: "M59.5,7.4c-.2,0-.3,0-.4-.2l-3.8-3.8c-.2-.2-.2-.6,0-.8l2.2-2.2c.2-.2.5-.3.8-.3s.6.1.8.3l3,3c.2.2.3.5.3.8s-.1.6-.3.8l-2.2,2.2c-.1.1-.3.2-.4.2ZM56.5,3l3,3,1.8-1.8s0,0,0,0l-3-3s0,0,0,0l-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-eb4e4239-5a6b-4158-be46-1de29cc9d51a",
    d: "M40.4,22.6c-.1,0-.3,0-.4-.2-.2-.2-.2-.6,0-.8l1-1c.2-.2.6-.2.8,0,.2.2.2.6,0,.8l-1,1c-.1.1-.3.2-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-88300a3b-d17b-430a-9672-bad06e0124f4",
    d: "M47.6,61.5h-27c-.5,0-.9-.4-.9-.9v-2.9c0-.5.4-1,.9-1h27c.5,0,.9.4.9,1v2.9c0,.5-.4.9-.9.9ZM20.9,60.4h26.6v-2.5h-26.6v2.5h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7251dbb4-513a-40d0-aac1-a55f355de765",
    x: 23.2,
    y: 57.3,
    width: 1.1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c6e21c13-d62f-40ca-8bfc-b47d3cdf9249",
    x: 26.7,
    y: 57.3,
    width: 1.1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7f967009-bcf1-49b4-b774-a1f49941394f",
    x: 30.1,
    y: 57.3,
    width: 1.1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c8f16124-ae74-4990-a58c-b98a13f05f35",
    x: 33.6,
    y: 57.3,
    width: 1.1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f69c4c26-8599-4ee2-84ef-b31a0e448b1c",
    d: "M10.3,32.2c-3.4,0-6.1-2.8-6.1-6.1s.3-.6.6-.6.6.3.6.6c0,2.8,2.2,5,5,5s5-2.2,5-5-2.2-5-5-5-.6-.3-.6-.6.3-.6.6-.6c3.4,0,6.1,2.8,6.1,6.1,0,3.4-2.8,6.1-6.1,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7fe2abb6-afdc-4a31-bf32-39eb9949ffd9",
    d: "M12.8,26.6h-5c-.3,0-.6-.3-.6-.6s.3-.6.6-.6h5c.3,0,.6.3.6.6s-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-3a18c988-6550-4dd3-96f1-c5afa55cd5f4",
    d: "M58,32.2c-3.4,0-6.1-2.8-6.1-6.1s.3-.6.6-.6.6.3.6.6c0,2.8,2.2,5,5,5s5-2.2,5-5-2.2-5-5-5-.6-.3-.6-.6.3-.6.6-.6c3.4,0,6.1,2.8,6.1,6.1,0,3.4-2.8,6.1-6.1,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0cdbf39e-6e86-4718-ab7f-ac3c8d713b52",
    d: "M60.5,26.6h-5c-.3,0-.6-.3-.6-.6s.3-.6.6-.6h5c.3,0,.6.3.6.6,0,.3-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-79b87dfc-9b09-4c8e-b47b-7c417fe1a112",
    d: "M58,29.1c-.3,0-.6-.3-.6-.6v-5c0-.3.3-.6.6-.6s.6.3.6.6v5c0,.3-.3.6-.6.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingDesign);
export default __webpack_public_path__ + "static/media/Packaging Design.862ea391d662cf67a170a5fd4e3550dc.svg";
export { ForwardRef as ReactComponent };